import { useResolve } from "@movicoders/di";
import { Navigate } from "react-router-dom";
import { Resource, ResourceType } from "@movicoders/ui";
import { IsValidImpersonationUseCase } from "@application/impersonation/is-valid-impersonation-use-case";

export const WithTenantResource = (props: ResourceType) => {
  const isValidImpersonationUseCase = useResolve(IsValidImpersonationUseCase);
  return isValidImpersonationUseCase.execute() ? <Resource {...props} /> : <Navigate to="/" />;
};
